import { MainButton, Text } from '@bizzabo/design-system';
import { makeStyles } from '@material-ui/styles';
import { joinChannelAtom } from '../atoms';
import { useSetAtom } from 'jotai';
import useTypeTracking from '../../../analytics';
import { UserData } from '@bizzabo/entities';

interface JoinButtonProps {
    currentUser: UserData;
}

const JoinButton: React.FC<JoinButtonProps> = ({ currentUser }) => {
    const classes = useStyles();
    const setJoinChannel = useSetAtom(joinChannelAtom);
    const { trackClickEvent } = useTypeTracking();

    const joinVideoHandle = () => {
        setJoinChannel(currentUser.userProfileId);
        trackClickEvent({
            buttonType: 'VIDEO_NOTIFICATIONS',
            subCategory: 'JOINED_MEETING_REQUEST',
        });
    };

    return (
        <MainButton
            variant="fill"
            size="large"
            className={classes.joinButton}
            onClick={joinVideoHandle}
        >
            <Text variant="t60">Join</Text>
        </MainButton>
    );
};

const useStyles = makeStyles(
    theme => ({
        joinButton: {
            backgroundColor: theme.palette.accent[500],
            lineHeight: 0,
        },
    }),
    { classNamePrefix: 'video-notifications-join-button' }
);

export default JoinButton;
